<app-topnav></app-topnav>
<main class="inner-content">
    <div id="loadconent" style="background-color:#000">
        <div class="col-md-12 col-12 p-3" style="color:#F5B942">
            <h1 style="border-bottom:solid 1px;font-size: 1em;" align="center"><i class="icofont-star"></i><i
                    class="icofont-video-clapper"></i>CELEBS LOVE US <i class="icofont-video-clapper"></i><i
                    class="icofont-star"></i></h1>
            <div class="row">
                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">SHAKTI KAPOOR</div>
                    <h4><img src="/assets/images/celebs/s1.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '1')"></div>

                </div>
                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">KARISHMA TANNA</div>
                    <h4><img src="/assets/images/celebs/s2.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '2')"></div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">MADALSA SHARMA</div>
                    <h4><img src="/assets/images/celebs/s3.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '3')"></div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">ZOYA AFROZ</div>
                    <h4><img src="/assets/images/celebs/s4.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '4')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">DEEPSHIKHA NAGPAL</div>
                    <h4><img src="/assets/images/celebs/s6.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '6')"></div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">AMIT TANDON</div>
                    <h4><img src="/assets/images/celebs/s7.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '7')"></div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">AMBIKA RANJANKAR</div>
                    <h4><img src="/assets/images/celebs/s8.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '8')"></div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">ADHYAYAN SUMAN</div>
                    <h4><img src="/assets/images/celebs/s9.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '9')"></div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">RUSHAD RANA</div>
                    <h4><img src="/assets/images/celebs/s10.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '10')"></div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">ROOPAL TYAGI</div>
                    <h4><img src="/assets/images/celebs/s11.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '11')"></div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">FALAQ NAAZ</div>
                    <h4><img src="/assets/images/celebs/s12.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '12')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">SNEHA ULLAL</div>
                    <h4><img src="/assets/images/celebs/s13.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '13')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">KARAN PATEL</div>
                    <h4><img src="/assets/images/celebs/s14.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '14')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">DAISY SHAH</div>
                    <h4><img src="/assets/images/celebs/s15.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '15')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">SHAMITA SHETTY</div>
                    <h4><img src="/assets/images/celebs/s16.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '16')"></div>
                </div>


                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">SAPNA CHOUDHARY</div>
                    <h4><img src="/assets/images/celebs/s17.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '17')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">HINA KHAN</div>
                    <h4><img src="/assets/images/celebs/s18.png"
                            class="img-responsive  border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '18')"></div>

                </div>
                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">KAINAAT ARORA</div>
                    <h4><img src="/assets/images/celebs/s19.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '19')"></div>

                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">KAPPU</div>
                    <h4><img src="/assets/images/celebs/s20.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '20')"></div>
                </div>




                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">KHUSHI GANDHAVI</div>
                    <h4><img src="/assets/images/celebs/s21.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '21')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">BHAVIKA KATARIYA</div>
                    <h4><img src="/assets/images/celebs/s22.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '22')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">BEBO NAMITA</div>
                    <h4><img src="/assets/images/celebs/s23.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '23')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">SUSHANT PAL</div>
                    <h4><img src="/assets/images/celebs/s24.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '24')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">SENHAL PRADHAN</div>
                    <h4><img src="/assets/images/celebs/s25.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '25')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">SHALAGHAYA SHARMA</div>
                    <h4><img src="/assets/images/celebs/s26.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '26')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">SALONI RAJPUT</div>
                    <h4><img src="/assets/images/celebs/s27.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '27')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">ANAMTA HASAN</div>
                    <h4><img src="/assets/images/celebs/s28.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '28')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">SANDHYA DANETI</div>
                    <h4><img src="/assets/images/celebs/s29.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '29')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">KUMKUM MANTRI</div>
                    <h4><img src="/assets/images/celebs/s30.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '30')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">BRISHTI SAMADDAR</div>
                    <h4><img src="/assets/images/celebs/s31.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '31')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">SHREE BISWAS</div>
                    <h4><img src="/assets/images/celebs/s32.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '32')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">TRISHAA KAMLAKAR</div>
                    <h4><img src="/assets/images/celebs/s33.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '33')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">SHEFALI THAKUR</div>
                    <h4><img src="/assets/images/celebs/s34.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '34')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">OSHNI ARYA</div>
                    <h4><img src="/assets/images/celebs/s35.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '35')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">NIKITA VAID</div>
                    <h4><img src="/assets/images/celebs/s36.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '36')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">ALIYA GHOSHAM</div>
                    <h4><img src="/assets/images/celebs/s37.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '37')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">AYESHA KAUR</div>
                    <h4><img src="/assets/images/celebs/s38.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '38')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">STARBOU SUPERMACY</div>
                    <h4><img src="/assets/images/celebs/s39.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '39')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">ANKIT MEWARA</div>
                    <h4><img src="/assets/images/celebs/s40.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '40')"></div>
                </div>



                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">QUEEN MAIZ</div>
                    <h4><img src="/assets/images/celebs/s41.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '41')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">SAM KILLERZZ</div>
                    <h4><img src="/assets/images/celebs/s42.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '42')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">DARSHAN LY</div>
                    <h4><img src="/assets/images/celebs/s43.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '43')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">DILKUSH DIVYA</div>
                    <h4><img src="/assets/images/celebs/s44.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '44')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">ESHA BHATTARAI</div>
                    <h4><img src="/assets/images/celebs/s45.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '45')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">SHREYAL PANDEY</div>
                    <h4><img src="/assets/images/celebs/s46.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '46')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">SANDHYA RAGHAV</div>
                    <h4><img src="/assets/images/celebs/s47.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '47')"></div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="itemtitle1">PRIYANKA KUMAR SONI</div>
                    <h4><img src="/assets/images/celebs/s48.png"
                            class="img-responsive border border-5 border-warning rounded w-100"></h4>
                    <div class="play-button" (click)="playvideo(celebModal, '48')"></div>
                </div>

            </div>


        </div>




    </div>
</main>

<!-- Modal -->
<ng-template #celebModal>
    <div class="modal-header" style="padding:0px;">
        &nbsp;&nbsp;<div class="modal-title" style="font-weight:bold; ">Celebs <span class="badge badge-warning" id="vidtitle">KARISHMA TANNA</span></div>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="stopvideo()">
            <span aria-hidden="true">×</span>&nbsp;&nbsp;
        </button> 
    </div>
    <!-- <div class="modal-header">
      <h4 class="modal-title pull-left" id="vidtitle">Celebs Name</h4>
      <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="stopvideo()">
        <span aria-hidden="true" class="visually-hidden">&times;</span>
      </button>
    </div> -->
    <div class="modal-body" id="datacelb">
      <!-- <video controls="" autoplay="true" width="100%" onended="runsend(10)"><source src="//mango777.com/video/s10.mp4" type="video/mp4"></video> -->
    </div>
</ng-template>